import axiosInstance from "../lib/axiosInstance";
const baseUrl = process.env.REACT_APP_API_URL;

const FormsModel = class {
    async seeker_network() {
        const data = await axiosInstance.get(baseUrl+"/admin/seeker_network");
        return data;
    }    
    async career() {
        const data = await axiosInstance.get(baseUrl+"/admin/careers");
        return data;
    }
    async founding_buddy() {
        const data = await axiosInstance.get(baseUrl+"/admin/founding_buddy");
        return data;
    }
    async community() {
        const data = await axiosInstance.get(baseUrl+"/admin/community");
        return data;
    }
    async partnership() {
        const data = await axiosInstance.get(baseUrl+"/admin/partnership");
        return data;
    }
    async investor_relation() {
        const data = await axiosInstance.get(baseUrl+"/admin/investor_relation");
        return data;
    }
}

export default new FormsModel();
